module.exports = __webpack_public_path__ + "static/media/no-view.c0c5ba16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-view.svg
// module id = 481
// module chunks = 0